import CategoryBackground from './CategoryBackground';

export default CategoryBackground;
